import { Button, DefaultTheme, Select } from "@deliverr/ui";
import { SortationGaylordType } from "@deliverr/sortation-client";
import styled from "@emotion/styled";
import React from "react";
import { FormattedMessage } from "react-intl";
import { useGaylordPrint } from "sortation/pages/LabelPrint/GaylordLabel/useGaylordPrint";
import { gaylordLabelOptions } from "sortation/pages/LabelPrint/GaylordLabel/gaylordOptions";

const Card = styled.div<{}, DefaultTheme>(
  ({ theme }) => `
  padding: ${theme.spacing.S5};
  background: ${theme.colors.NEUTRAL["00"]};
  border-radius: ${theme.border.radius.R5};
  box-shadow: ${theme.shadow.S2};
  margin-bottom: ${theme.spacing.S5};
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.S4};
`
);

export const MasterCartonLabel = () => {
  const {
    selectedNumberOfLabels,
    handleNumberOfLabelsChange,
    createGaylords,
    createGaylordState,
    hasConnectedPrinter,
  } = useGaylordPrint(SortationGaylordType.MASTER_CARTON);

  return (
    <>
      <Card>
        <Select
          label="Select number of master carton labels"
          value={selectedNumberOfLabels}
          options={gaylordLabelOptions}
          onChange={handleNumberOfLabelsChange}
          data-testid="master_carton_select"
        />
      </Card>
      <Button
        disabled={!hasConnectedPrinter}
        loading={createGaylordState.loading}
        block
        onClick={createGaylords}
        data-testid="master_carton_print"
      >
        <FormattedMessage id="sortation.printLabel.masterCarton.printButton" defaultMessage="Print label(s)" />
      </Button>
    </>
  );
};
